import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabOrgao = '/service/contabilidade/funcaoDespesa/'

class FuncoesService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getFuncoes(exercicio) {
        return this.conex.get(urlTabOrgao + 'recuperarFuncao/' + exercicio)
    }

    getSubFuncoes(exercicio) {
        return this.conex.get(urlTabOrgao + 'recuperarSubFuncao/' + exercicio)
    }

    getDespesas(exercicio) {
        return this.conex.get(urlTabOrgao + 'recuperarDespesa/' + exercicio)
    }
}

export default FuncoesService
